import {OutlinedInput,} from "@mui/material";

const ReportingTextInput = ({
  value,
  onChange,
  onBlur,
  type,
  sx,
  placeholder,
  disabled,
  numberUnit = "%",
  min = -100,
  max = 100,
  ...props
}) => {
  return (
    <OutlinedInput
      disabled={disabled}
      sx={{
        backgroundColor: "white",
        borderRadius: "4px",

        "& .MuiInputBase-input.MuiOutlinedInput-input": {
          padding: "0px",
          paddingBottom: "3px",
          paddingTop: "3px",
          paddingRight: "2px",
          textAlign: "right",
        },
        "&.MuiInputBase-root.Mui-disabled": {
          background: "#EBEBEB",
        },

        input: {
          "&::placeholder": {
            fontSize: "12px",
          },
        },
        ...sx,
      }}
      id="filled-size-small"
      variant="outlined"
      value={value}
      type={type === "number" ? "number" : "text"}
      inputProps={{
        itemType: "numeric",
        max,
        min,
      }}
      endAdornment={
        <>
          <span style={{ fontSize: "14px", color: "#BAB7B7" }}>
            {numberUnit}
          </span>
          <span>{props.endAdornment}</span>
        </>
      }
      onChange={onChange}
      onBlur={onBlur}
      size="small"
      placeholder={placeholder}
      {...props}
    />
  );
};
export default ReportingTextInput;
